'use es6';

import { getCookie } from 'hub-http/helpers/cookies';
import { hstcKey } from 'usage-tracker-core/storageKeys';
export const get = key => getCookie(key, document.cookie);
export const set = (key, value, expiresInMillis = 60 * 24 * 60 * 60 * 1000) => {
  const currentTime = new Date();
  const expiryTime = new Date(currentTime.setTime(currentTime.getTime() + expiresInMillis)).toUTCString();
  document.cookie = `${key}=${value};expires=${expiryTime};path=/`;
};
export function getHstc() {
  return get(hstcKey) || null;
}
export function getUtk() {
  let utk = get('hubspotutk');

  if (!utk) {
    utk = getHstc();

    if (utk) {
      utk = utk.split('.')[1];
    }
  }

  return utk || null;
}